import { useEffect, useState } from 'react';

import { gql, useQuery } from '@apollo/client';

import { IFilterData } from 'src/pages/settings/components/user-management/user-management.interfaces';

export const GET_MEMBERS = gql`
  query ($filter: FilterMemberInput, $queryOptions: QueryOptionsInput) {
    getMembers(filter: $filter, queryOptions: $queryOptions) {
      collection {
        _id
        createdAt
        createdBy
        type
        ganttsAccess {
          accessRight
          ganttId
        }
        companyPosition {
          _id
          name
        }
        account {
          _id
          email
          active
          twoFA
          accountFillStage
          permissionGroup
          permissionGroupId
        }
        profile {
          firstName
          lastName
          displayName
          phoneNumber
        }
      }
      totalCount
    }
  }
`;

export const useGetMembers = ({ accountStatuses, ...filter }: IFilterData) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>();
  const pageSize = 12;
  const { data, loading } = useQuery(GET_MEMBERS, {
    variables: {
      filter: {
        ...filter,
        ...(accountStatuses?.length && { accountActive: accountStatuses?.includes('active') }),
      },
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
  });

  const { totalCount = 0, collection = [] } = data?.getMembers || {};

  useEffect(() => setPage(1), [accountStatuses, filter.searchParam]);

  return {
    loading,
    members: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'name', sortBy }]);
      }
    },
  };
};

export const useGetAllMembers = ({ accountStatuses, ...filter }: IFilterData) => {
  const { data, loading } = useQuery(GET_MEMBERS, {
    variables: {
      filter: {
        ...filter,
        ...(accountStatuses?.length && { accountActive: accountStatuses?.includes('active') }),
      },
    },
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getMembers || {};

  return { members: collection, loading, totalCount };
};
